module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/288.31252816.png";